'use strict';var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}();function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}} // Copyright 2015-2017 Parity Technologies (UK) Ltd.
// This file is part of Parity.

// Parity is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.

// Parity is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.

// You should have received a copy of the GNU General Public License
// along with Parity.  If not, see <http://www.gnu.org/licenses/>.

var TYPES = ['raw', 'prefixed', 'fixedArray', 'array'];var _require =

require('../util/pad'),padU32 = _require.padU32;var

Mediate = function () {
  function Mediate(type, value) {_classCallCheck(this, Mediate);
    Mediate.validateType(type);

    this._type = type;
    this._value = value;
  }_createClass(Mediate, [{ key: 'initLength', value: function initLength()

    {
      switch (this._type) {
        case 'raw':
          return this._value.length / 2;

        case 'array':
        case 'prefixed':
          return 32;

        case 'fixedArray':
          return this._value.
          reduce(function (total, mediate) {
            return total + mediate.initLength();
          }, 0);}

    } }, { key: 'closingLength', value: function closingLength()

    {
      switch (this._type) {
        case 'raw':
          return 0;

        case 'prefixed':
          return this._value.length / 2;

        case 'array':
          return this._value.
          reduce(function (total, mediate) {
            return total + mediate.initLength();
          }, 32);

        case 'fixedArray':
          return this._value.
          reduce(function (total, mediate) {
            return total + mediate.initLength() + mediate.closingLength();
          }, 0);}

    } }, { key: 'init', value: function init(

    suffixOffset) {var _this = this;
      switch (this._type) {
        case 'raw':
          return this._value;

        case 'fixedArray':
          return this._value.
          map(function (mediate, index) {return mediate.init(Mediate.offsetFor(_this._value, index)).toString(16);}).
          join('');

        case 'prefixed':
        case 'array':
          return padU32(suffixOffset);}

    } }, { key: 'closing', value: function closing(

    offset) {var _this2 = this;
      switch (this._type) {
        case 'raw':
          return '';

        case 'prefixed':
          return this._value;

        case 'fixedArray':
          return this._value.
          map(function (mediate, index) {return mediate.closing(Mediate.offsetFor(_this2._value, index)).toString(16);}).
          join('');

        case 'array':
          var prefix = padU32(this._value.length);
          var inits = this._value.
          map(function (mediate, index) {return mediate.init(offset + Mediate.offsetFor(_this2._value, index) + 32).toString(16);}).
          join('');
          var closings = this._value.
          map(function (mediate, index) {return mediate.closing(offset + Mediate.offsetFor(_this2._value, index)).toString(16);}).
          join('');

          return '' + prefix + inits + closings;}

    } }, { key: 'type', get: function get()

    {
      return this._type;
    } }, { key: 'value', get: function get()

    {
      return this._value;
    } }]);return Mediate;}();


Mediate.offsetFor = function (mediates, position) {
  if (position < 0 || position >= mediates.length) {
    throw new Error('Invalid position ' + position + ' specified for Mediate.offsetFor');
  }

  var initLength = mediates.
  reduce(function (total, mediate) {
    return total + mediate.initLength();
  }, 0);

  return mediates.
  slice(0, position).
  reduce(function (total, mediate) {
    return total + mediate.closingLength();
  }, initLength);
};

Mediate.validateType = function (type) {
  if (TYPES.filter(function (_type) {return type === _type;}).length) {
    return true;
  }

  throw new Error('Invalid type ' + type + ' received for Mediate.validateType');
};

module.exports = Mediate;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@parity/abi/lib/encoder/mediate.js
// module id = 419
// module chunks = 0